// extracted by mini-css-extract-plugin
module.exports = {"blue300":"#14267B","acceptBox":"AcceptBox_acceptBox__0qTfD","acceptBoxCheckbox":"AcceptBox_acceptBoxCheckbox__3D68r","acceptBoxLink":"AcceptBox_acceptBoxLink__ZVCii"};